<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Set as Free ({{ company }})</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <form-wrapper :validator="$v.model" class="form-wrapper">
                <md-datepicker ref="mdDatePicker" v-model="model.freeUntilDate" md-immediately :md-debounce="10">
                    <label>Free End Date</label>
                </md-datepicker>
                <form-group name="freeUsersAllowed" label="Maximum Free Users Allowed">
                    <md-input v-model="model.freeUsersAllowed" />
                </form-group>
                <form-group name="reason" label="Reason">
                    <md-textarea v-model="model.reason" />
                </form-group>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="dialog-button md-primary" @click.stop="changeBillingStatusToFree">Update</md-button>
            <md-button class="dialog-button md-default" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>

<script>
import { handleRequests, showErrorMessage } from '@/helpers';
import { required, minValue, maxValue } from 'vuelidate/lib/validators';
import { GeneralMixin } from '@/mixins/GeneralMixin';

export default {
    name: 'SetFreeModal',
    mixins: [GeneralMixin],
    props: {
        teamId: { type: Number, required: true },
        company: { type: String, required: true },
        freeUntilDate: { type: String, required: true },
        freeUsersAllowed: { type: Number, required: true },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            model: {
                freeUntilDate: null,
                freeUsersAllowed: null,
                reason: null
            }
        };
    },
    validations() {
        return {
            model: {
                reason: { required },
                freeUsersAllowed: { required, minValue: minValue(1), maxValue: maxValue(999) }
            }
        };
    },
    methods: {
        async changeBillingStatusToFree() {
            this.$v.$touch();
            if (this.$v.$invalid) 
                return;

            this.$_handleLoaderState(true, `Updating ${this.company}'s billing status...`);

            try {
                const payload = {
                    method: 'post',
                    data: {
                        status: 'Free',
                        freeUntilDate: this.model.freeUntilDate,
                        freeUsersAllowed: this.model.freeUsersAllowed,
                        reason: this.model.reason
                    }
                };
                const api = `/api/support/teams/${this.teamId}/billing-status`;
                await handleRequests(api, payload);

                this.$notify({
                    message: "Team's billing account was updated successfully.",
                    type: 'success'
                });

                this.resolve(this.model);
            } catch (e) {
                const message = "Could not update team's billing status.";
                showErrorMessage(this, message, e);
            } finally {
                this.$_handleLoaderState(false);
            }
        }
    },
    mounted() {
        if (this.freeUntilDate) {
            this.model.freeUntilDate = new Date(this.freeUntilDate);
        }
        this.model.freeUsersAllowed = this.freeUsersAllowed;
    }
};
</script>
